import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BrokerService } from 'src/app/core/services/broker.service';
import { OfferService } from 'src/app/core/services/offer.service';
import { SesionService } from 'src/app/core/services/sesion.service';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { LoadService } from 'src/app/core/services/load.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-soft-filters',
  templateUrl: './soft-filters.component.html',
  styleUrls: ['./soft-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SoftFiltersComponent implements OnInit {

  arrayTypeOfHousing = [
    { value: 1, label: 'Arrendada' },
    { value: 2, label: 'Familiar' },
    { value: 3, label: 'Propiedad Hipotecada' },
    { value: 4, label: 'Otra' },
    { value: 5, label: 'Propiedad Libre' },
  ];

  arrayOccupation = [
    { value: 1, label: 'Estudiante' },
    { value: 2, label: 'Empleado' },
    { value: 3, label: 'Independiente' },
    { value: 4, label: 'Pensionado' },
    { value: 6, label: 'Microempresario' },
    { value: 7, label: 'Desempleado' },
    { value: 8, label: 'Cuidador/Ama de casa' },
    { value: 5, label: 'Otro' },
  ];

  arrayCivilStatus = [
    { value: 1, label: 'Casado' },
    { value: 2, label: 'Soltero' },
    { value: 3, label: 'Unión libre' },
    { value: 4, label: 'Divorciado' }
  ];

  arrayGender = [
    { value: 'M', label: 'Hombre' },
    { value: 'F', label: 'Mujer' },
  ];

  arrayDependentsNumber = [
    { value: 0, label: '0' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
  ]

  @Output() closeModalEvent = new EventEmitter<boolean>();
  @Output() updatePhoneEvent = new EventEmitter<boolean>();
  @Output() rejectedFiltersEvent = new EventEmitter<boolean>();


  softFilterObject: any = {};
  fieldCountObjetFilter: number = 0;
  stepSoftFilter: number = 1;
  maxStep: number = 3;
  stateValue: boolean = false;
  isFormValid: boolean = false;
  cities!: Array<any>;
  monthlyIncomeFormat: string = '';
  monthlyExpensesFormat: string = '';
  maxDate: Date = new Date();
  softFiltersRejectionReasons: any[] = [];

  public employmentTenure: number = 0;

  constructor(
    public broker: BrokerService,
    private cookieService: CookieService,
    public offerService: OfferService,
    public sesion: SesionService,
    public utilities: UtilitiesService,
    public load: LoadService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getCities();
    this.offerService.softFilterList.forEach(item => {
      this.getObjectFilter(item);
    });
    this.fieldCountObjetFilter = Object.keys(this.softFilterObject).length;
    this.getFilterByStep();
    this.maxStep = this.calculateMaxStep();
  }

  private setRenderFilter(key: string, value: boolean): void {
    switch (key) {
      case 'typeOfHousing': if (this.softFilterObject.typeOfHousing) this.softFilterObject.typeOfHousing.renderFilter = value; break;
      case 'occupation': if (this.softFilterObject.occupation) this.softFilterObject.occupation.renderFilter = value; break;
      case 'monthlyIncome': if (this.softFilterObject.monthlyIncome) this.softFilterObject.monthlyIncome.renderFilter = value; break;
      case 'monthlyExpenses': if (this.softFilterObject.monthlyExpenses) this.softFilterObject.monthlyExpenses.renderFilter = value; break;
      case 'civilStatus': if (this.softFilterObject.civilStatus) this.softFilterObject.civilStatus.renderFilter = value; break;
      case 'employmentTenure': if (this.softFilterObject.employmentTenure) this.softFilterObject.employmentTenure.renderFilter = value; break;
      case 'daneId': if (this.softFilterObject.daneId) this.softFilterObject.daneId.renderFilter = value; break;
      case 'birthDate': if (this.softFilterObject.birthDate) this.softFilterObject.birthDate.renderFilter = value; break;
      case 'expeditionDate': if (this.softFilterObject.expeditionDate) this.softFilterObject.expeditionDate.renderFilter = value; break;
      case 'gender': if (this.softFilterObject.gender) this.softFilterObject.gender.renderFilter = value; break;
      case 'dependentsNumber': if (this.softFilterObject.dependentsNumber) this.softFilterObject.dependentsNumber.renderFilter = value; break;
    }
  }

  getFilterByStep() {
    const keys = Object.keys(this.softFilterObject).filter(k => this.allowedFilterKeys.has(k));
    if (this.stepSoftFilter == 1 && this.fieldCountObjetFilter < 5) {
      keys.forEach((key, index) => this.setRenderFilter(key, index < 4));
    } else if (this.stepSoftFilter == 1) {
      keys.forEach((key, index) => this.setRenderFilter(key, index < 3));
    } else if (this.stepSoftFilter == 2) {
      keys.forEach((key, index) => this.setRenderFilter(key, index > 2 && index < 8));
    } else {
      keys.forEach((key, index) => this.setRenderFilter(key, index > 7));
    }
  }

  getObjectFilter(item: any) {
    if (item.passed) {
      return;
    }
    const filterName: string = String(item.filterName);
    if (!this.allowedFilterKeys.has(filterName)) {
      return;
    }
    this.softFilterObject[filterName] = {
      passed: item.passed,
      filterName,
      evaluated: item.evaluated,
      renderFilter: false,
      value: undefined,
      customerValue: item.customerValue
    };
  }

  calculateMaxStep() {
    let arrayLength = this.fieldCountObjetFilter;
    if (arrayLength <= 4) return 1;

    const remainingItems = arrayLength - 3;
    const extraPages = Math.ceil(remainingItems / 5);

    return 1 + extraPages;

  }

  rejectedOffer() {
    let sourceOfTraffic = '';
    let campaignOfTraffic = '';
    let mediumOfTraffic = '';
    if ((Object.keys(this.utilities.utmParams).length > 0)) {
      for (const key in this.utilities.utmParams) {
        if (key.toLowerCase() == 'utm_source') {
          sourceOfTraffic = this.utilities.utmParams[key]
        }
        if (key.toLowerCase() == 'utm_medium') {
          mediumOfTraffic = this.utilities.utmParams[key]
        }
        if (key.toLowerCase() == 'utm_campaign') {
          campaignOfTraffic = this.utilities.utmParams[key]
        }
      }
    }
    let bodyOffer: any = {
      idSession: this.sesion.sesionCookie,
      companyId: this.offerService.offerSelected.company.id,
      offerId: this.offerService.offerSelected.offerId,
      filter: true,
      softFiltersRejectionReasons: this.softFiltersRejectionReasons,
      sourceOfTraffic: sourceOfTraffic,
      campaignOfTraffic: campaignOfTraffic,
      mediumOfTraffic: mediumOfTraffic
    };
    this.broker.aplicarOferta(bodyOffer).subscribe({
      next: (result: any) => {
        this.load.isInProcess = false;
        this.rejectedFiltersEvent.emit(true);
      },
      error: (error: any) => {
        this.load.isInProcess = false;
        console.error(error);
      }
    });
  }

  validateFilters() {
    let request = {
      idSession: this.cookieService.get('IDSESSIONMDC'),
      companyId: this.offerService.offerSelected.company.id,
      offerId: this.offerService.offerSelected.offerId
    }
    this.broker.softFilters(request).subscribe({
      next: (res: any) => {
        if (Array.isArray(res) && res.length > 0) {
          this.softFiltersRejectionReasons = this.getRejectedFilters(res);
          if (this.softFiltersRejectionReasons.length > 0) {
            this.rejectedOffer();
          } else {
            this.load.isInProcess = false;
            this.rejectedFiltersEvent.emit(false);
          }
        } else {
          this.load.isInProcess = false;
          this.rejectedFiltersEvent.emit(false);
        }
      },
      error: (err: any) => {
        console.error(err);
        this.load.isInProcess = false;
      }
    });
  }

  getRejectedFilters(rejectedArray: any[]) {
    return rejectedArray
      .filter((filter: any) => {
        filter?.status === true &&
          filter?.evaluated === true &&
          filter?.passed === false &&
          this.allowedFilterKeys.has(filter.filterName) &&
          filter?.customerValue !== null &&
          filter?.customerValue !== undefined;
      })
      .map((filter: any) => ({
        filterName: filter.filterName,
        customerValue: filter.customerValue,
        value: filter.params
      }));
  }


  private readonly allowedFilterKeys: ReadonlySet<string> = new Set([
    'typeOfHousing', 'occupation', 'monthlyIncome', 'monthlyExpenses',
    'civilStatus', 'employmentTenure', 'daneId', 'birthDate',
    'expeditionDate', 'gender', 'dependentsNumber'
  ]);

  updateProfile() {
    this.load.isInProcess = true;
    const filters = this.softFilterObject;
    const dataUpdate: { [key: string]: any } = {
      ...(filters.typeOfHousing ? { typeOfHousing: filters.typeOfHousing.value } : {}),
      ...(filters.occupation ? { occupationCode: filters.occupation.value } : {}),
      ...(filters.monthlyIncome ? { monthlyIncome: filters.monthlyIncome.value } : {}),
      ...(filters.monthlyExpenses ? { monthlyExpenses: filters.monthlyExpenses.value } : {}),
      ...(filters.civilStatus ? { civilStatus: filters.civilStatus.value } : {}),
      ...(filters.employmentTenure ? { employmentTenure: filters.employmentTenure.value } : {}),
      ...(filters.daneId ? { daneId: filters.daneId.value } : {}),
      ...(filters.gender ? { gender: filters.gender.value } : {}),
      ...(filters.dependentsNumber ? { dependentsNumber: filters.dependentsNumber.value } : {}),
      ...(filters.birthDate?.value
        ? { birthDate: new Date(filters.birthDate.value).getTime().toString() } : {}),
      ...(filters.expeditionDate?.value
        ? { expeditionDate: new Date(filters.expeditionDate.value).getTime().toString() } : {}),
    };
    dataUpdate['idSession'] = this.cookieService.get('IDSESSIONMDC');
    dataUpdate['country'] = 'CO';
    this.broker.updateInfo(dataUpdate).subscribe(
      (result: any) => {
        if (result.code == "200") {
          this.validateFilters();
        }
        else {
          console.error("Error updateProfile");
          this.load.isInProcess = false;
        }
      },
      (error: any) => {
        console.error(error);
        //this.offerService.clearOfferlocalStorage(); 

        setTimeout(() => {
          this.load.isInProcess = false;
          this.load.close('#confirmationModalV2', true);

          // limpieza de modales
          setTimeout(() => {
            this.load.forceCleanupModals();
          }, 200);

          this.router.navigate(['/error']);
        }, 700);
      });
  }

  closeModalConfirm() {
    this.closeModalEvent.emit(true);
  }

  nextStep(step: number = 0) {
    if (step > 0) {
      this.stepSoftFilter = step;
    } else {
      this.stepSoftFilter++;
    }
    this.getFilterByStep();
  }

  passSoftFilter() {
    if (this.stepSoftFilter != this.maxStep) {
      this.nextStep();
    } else {
      this.updateProfile();
    }
  }

  validateForm() {
    this.isFormValid = true;
    const keys = Object.keys(this.softFilterObject);
    if (this.stepSoftFilter == this.maxStep) {
      keys.forEach(key => {
        if (this.softFilterObject[key].value == undefined) {
          this.isFormValid = false;
        }
      });
    } else {
      keys.forEach(key => {
        if (this.softFilterObject[key].renderFilter && this.softFilterObject[key].value == undefined) {
          this.isFormValid = false;
        }
      });
    }
    return this.isFormValid;
  }

  getCities() {
    this.broker.getCities().subscribe((data: any) => {
      this.cities = data;
      this.cities = this.cities.map(obj => ({
        value: obj.COD_MUN,
        label: obj.NAME_MUN
      }));

      const model = this;
      this.cities.sort(function (a: any, b: any) {
        return model.compareStrings(a.label, b.label);
      });
    });
  }

  compareStrings(a: any, b: any) {
    a = a.toLowerCase();
    b = b.toLowerCase();
    return (a < b) ? -1 : (a > b) ? 1 : 0;
  }

  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\./g, '').replace(/\D/g, '');
    let valueFormat = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (input.name == 'monthlyIncome') {
      this.monthlyIncomeFormat = valueFormat;
      this.softFilterObject.monthlyIncome.value = Number(valueFormat.split('.').join(''));
    } else {
      this.monthlyExpensesFormat = valueFormat;
      this.softFilterObject.monthlyExpenses.value = Number(valueFormat.split('.').join(''));
    }

  }

  updatePhone() {
    this.updatePhoneEvent.emit(true);
  }

  formatBirthDateInput(event: Event, key: string) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');

    if (value.length >= 2) {
      value = value.substring(0, 2) + '/' + value.substring(2);
    }
    if (value.length >= 5) {
      value = value.substring(0, 5) + '/' + value.substring(5, 9);
    }

    input.value = value;

    if (value.length === 10) {
      const parts = value.split('/');
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);

      const date = new Date(year, month, day);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (date.getFullYear() === year && date.getMonth() === month && date.getDate() === day && date <= today) {
        this.softFilterObject[key].value = date;
      } else if (date > today) {
        this.softFilterObject[key].value = null;
        input.value = '';
      }
    }
  }

  setValueTypeOfHousing(event: any) {
    this.softFilterObject.typeOfHousing.value = event.value;
  }

  setValueOccupation(event: any) {
    this.softFilterObject.occupation.value = event.value;
  }

  setValueCivilStatus(event: any) {
    this.softFilterObject.civilStatus.value = event.value;
  }

  setValueDaneId(event: any) {
    this.softFilterObject.daneId.value = event.value;
  }

  setValueGender(event: any) {
    this.softFilterObject.gender.value = event.value;
  }

  setValueDependentsNumber(event: any) {
    this.softFilterObject.dependentsNumber.value = event.value;
  }

}
